import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import { filter } from 'lodash';
import TabNavigations from '@src/components/TabNavigations';
import { USER_PROFILE_ROUTE, USER_PROFILE_SECURITY_ROUTE } from '@src/Routes/links';
import { Security } from './Security';
import { EditProfile } from './EditProfile';
import './styles.scss';

const TABS = [
  {
    isShown: true,
    label: 'Edit Details',
    name: 'billing',
    to: USER_PROFILE_ROUTE,
  },
  {
    isShown: true,
    label: 'Security',
    name: 'company-information',
    to: USER_PROFILE_SECURITY_ROUTE,
  },
];

export const UserProfile: FC = () => {
  return (
    <div className="user-profile">
      <div className="user-profile__header">
        <div className="user-profile__header-title">My Profile</div>

        <TabNavigations className="user-profile__tabs" tabs={filter(TABS, 'isShown')} />
      </div>

      <div className="user-profile__body">
        <Switch>
          <Route exact path={USER_PROFILE_ROUTE}>
            <EditProfile />
          </Route>

          <Route exact path={USER_PROFILE_SECURITY_ROUTE}>
            <Security />
          </Route>
        </Switch>
      </div>
    </div>
  );
};
